import { controls, currencyToNumber, grouped } from "../../controls";

const bwul = {
  label: "Branch Wise Unpaid List",
  starting: true,
  url: "bwu",
  pageLabel: "Branch Wise Unpaid List",
  pageType: "history",
  // filteraction: true,
  filter: [

    // ...controls.displayText({ tab: "general", label: "Bank", star: false }),
    // ...controls.oc({ tab: "general", c: "Bank", placeHolder: "Bank Code", name: "bank_code", defaultValue: 'pdcc', fastpath: "banks", clearData: ['branch_code'], hidden: true }),
    // ...controls.showData({ tab: "general", displaytype: "capital", data: "bank_display" }),
    // ...controls.displayText({ tab: "general", label: "Branch", star: false }),
    // ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches", sendToServer: { sendData: [{ varname: 'bank.bank_uid', value: 'bank_uid' }] }, hidden: false }),
    // ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),

    ...controls.displayText({ label: "Branch Code", width: "col-sm-1" }),
    ...controls.text({ placeHolder: "EX(0002)", name: "branch_code", width: "col-sm-2" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Branch Wise Unpaid List",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    pivot: true,
    extraRows: {
      location: "top",
      fields: ["total_amount"],
      grandtotal: { type: "fixed", displayIn: "is_account_suggested_by_bank", val: "Grand Total", count: true },
    },


    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Full Name",
        accessor: "full_name"
      },
      {
        Header: "Account Number",
        accessor: "account_no"
      },
      {
        Header: "Village",
        accessor: "village_display"
      },

      {
        Header: "Taluka",
        accessor: "taluka_display"
      },
      {
        Header: "Validation Reason",
        accessor: "validation_reason"
      },
      {
        Header: "Is Account Suggested By Bank",
        accessor: "is_account_suggested_by_bank"

      },
      {
        Header: "Total Amount",
        accessor: "total_amount"
      },
      {
        Header: "Branch Display",
        accessor: "branch_display"
      },

    ]

  }
};

export default bwul;